import { InjectionToken } from '@angular/core';
import { Section } from '../../public_api';
import { Data } from './data';

/**
 * based on ctx returns a string denoting a finding, usually
 * used to return invalid values
 */
export type ValidationRule = (ctx: Data, section: Partial<Section>) => string;

/**
 * Token to be used to declare providers with multi true that can be used
 * injected by name
 */
export const ValidationRuleToken = new InjectionToken<ValidationRule>('ValidationRule');

export interface BusinessValidationRules {
  /**
   * rules intended to be used on record creation (e.g isNewRecord)
   */
  onCreate?: (ValidationRule | string)[];
  /**
   * rules intended to be used on record creation (e.g !isNewRecord && !isCloneRecord)
   */
  onUpdate?: (ValidationRule | string)[];
  /**
   * rules intended to be used on both record creation & update
   */
  onSave?: (ValidationRule | string)[];
}
